const APP_DATA = {
  title: "Buy | C3 Tubular",
  baseUrl: "https://api-c3-tubular.canucks-publishing.com/",
  launchDate: "2021-10-06T23:30:00Z", //GMT (actual launch time)
  // launchDate: "2021-10-04T23:30:00Z", //DON'T USE THIS
  policyId: "09b1b803d93666547abaa825425da69baf03d09681c1b990c0a3c096",
  preloadedProductIndex: 0
}

export default APP_DATA;